import * as f from "react";
import { i as d, b as x, E as h, a as c, x as m, r as b, c as g } from "../createReactComponent-58f9bea8.mjs";
import { n as i } from "../property-9daa16cd.mjs";
import { o as u } from "../style-map-c3339321.mjs";
import { d as y, r as v } from "../icon-button-a9d2a2d1.mjs";
import { r as w } from "../tooltip-cb602d1f.mjs";
import "../class-map-2994e95e.mjs";
import "../icon-c572aa57.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
var z = Object.defineProperty, C = Object.getOwnPropertyDescriptor, l = (t, r, a, n) => {
  for (var s, o = n > 1 ? void 0 : n ? C(r, a) : r, p = t.length - 1; p >= 0; p--)
    (s = t[p]) && (o = (n ? s(r, a, o) : s(o)) || o);
  return n && o && z(r, a, o), o;
}, $ = ((t) => (t.PARENT = "parent", t.DEFAULT = "default", t))($ || {}), _ = ((t) => (t.FLUID = "fluid", t.CUSTOM = "custom", t))(_ || {});
class e extends h {
  constructor() {
    super(...arguments), this.type = "default", this.width = "custom", this.text = "", this.required = !1, this.tooltipContent = "";
  }
  renderTooltip() {
    return this.tooltipContent ? m`
      <ex-tooltip
        trigger="click"
        position="top"
        alignment="middle"
        part="tooltip-popup"
      >
        <ex-icon-button
          slot="anchor"
          part="tooltip-trigger"
          class="tooltip-trigger"
          icon="information"
          label="More information"
          type="tertiary"
          size="x-small"
          circular
          style="vertical-align: middle; margin-left: var(--exo-spacing-2x-small, 4px);"
        ></ex-icon-button>
        <div part="content">${this.tooltipContent}</div>
      </ex-tooltip>
    ` : c;
  }
  render() {
    const r = { color: this.textColor }, a = y("label-container", "label", `label--type-${this.type}`, `label--width-${this.width}`);
    return m`
      <span class=${a} style=${u(r)} part="wrapper">
        <slot>${this.text}</slot>
        ${this.renderTooltip()}
        ${this.required ? m`<span class="label__required" part="required-indicator"
              >(required)</span
            >` : c}
      </span>
    `;
  }
}
e.styles = d`
    ${x(`:host{display:inline-flex;font-family:var(--exo-font-family, sans-serif);font-size:var(--exo-font-size-medium, 1rem);line-height:var(--exo-line-height-medium, 1.5);color:var(--ex-color-font);box-sizing:border-box}:host *{box-sizing:border-box}:host:before,:host:after{box-sizing:border-box}:host:before .form-control,:host:after .form-control{position:relative}:host:before .form-control .form-control__label,:host:after .form-control .form-control__label{display:block}.label-container{display:inline-flex;align-items:center;gap:var(--exo-spacing-2x-small, 4px);font-size:var(--exo-font-size-small, .875rem);line-height:var(--exo-line-height-normal, 1.5);color:var(--exo-color-font, #333);width:100%}.label--type-default{font-weight:var(--exo-font-weight-normal, 400)}.label--type-parent{font-weight:var(--exo-font-weight-semibold, 600);font-size:var(--exo-font-size-medium, 1rem)}.label--width-custom{width:fit-content}.label--width-fluid{width:100%!important;justify-content:start}.label__required{color:var(--exo-color-text-subtle, #666);font-size:var(--exo-font-size-x-small, .75rem);margin-left:var(--exo-spacing-2x-small, 4px);-webkit-user-select:none;user-select:none;white-space:nowrap}.tooltip-trigger{vertical-align:middle;margin-left:0!important}
`)}
  `, l([i({ type: String, reflect: !0 })], e.prototype, "type", 2), l([i({ type: String, reflect: !0 })], e.prototype, "width", 2), l([i({ type: String })], e.prototype, "text", 2), l([i({ type: Boolean, reflect: !0 })], e.prototype, "required", 2), l([i({ type: String, attribute: "text-color" })], e.prototype, "textColor", 2), l([i({ type: String, attribute: "tooltip-content" })], e.prototype, "tooltipContent", 2);
const q = (t = "") => {
  w(t), v(t), b("ex-label", e, t);
}, P = g({ tagName: "ex-label", elementClass: e, react: f, events: {}, displayName: "ExLabel", registerWebComponent: q });
export {
  P as ExLabel,
  $ as LabelType,
  _ as LabelWidth,
  q as register
};
